query OrganizationBillingRequisites($id: ID!) {
  organization(id: $id) {
    id
    title
    billingRequisites {
      companyName
      registrationNumber
      vatNumber
      address
      contactName
      contactEmail
      invoiceEmails
      contractNumber
      contractDate
      filled
    }
  }
}
